import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-bootstrap';
import Prices from "../../components/prices/PricesTable";
import {ExternalLink, MailTo} from '../../components/helpers/EasyLinks'
import {Page, PagePanel} from "../../components/helpers/PagePanel";
import priceImage from '../../assets/images/itu-inside.jpg';
import "./Registration.css"
import OCITraining from "../../components/prices/OCI";

class RegistrationPage extends Component {
    render() {
        return (
            <Page className="registration">
                <PagePanel className='no-padding text-center' bgImage={priceImage}>
                    <div className="top">
                        <h1>Registration</h1>
                        <p className="lead">Register now for All Things Groovy</p>
                        <Prices/>
                        <OCITraining/>

                        <p className="lead">Tickets can be bought for one, two, or three days in any combination. When you buy tickets for
                            specific days, it is possible to request changes for which days they are valid until the first day of conference.
                        </p>
                        <p>The OCI Training Day with Paul King is provided by OCI. GR8Conf Europe handles the payment. Inquiries about the training should be sent to <MailTo email="training@objectcomputing.com"/>.</p>
                    </div>
                </PagePanel>
                <PagePanel>
                    <Grid>
                        <Row>
                            <Col xs={12}>
                                <p className="small small-print"><strong>The small print</strong>:</p>

                                <p className="small small-print">
                                    Prices here are in Euros, but the ticket system handles prices in Danish Kroner (DKK). We use an approximated
                                    exchange rate of 1€ to 7.50DKK.</p>

                                <p className="small small-print">If your company is from Denmark, VAT (Danish: Moms) is added. If you company is
                                    registred withing the EU and has a valid VAT number, Danish VAT will not be added, instead "reverse charge" is
                                    applied. If you or your company is not registred in the EU, VAT will be added. If your company is outside the EU,
                                    no VAT will be added.</p>
                                <p className="small small-print">We use <ExternalLink link="http://flexbillet.dk">Flexbillet</ExternalLink> as our
                                    ticket broker. If you or your company is not be able to register and pay by credit card, we have other
                                    options available. Please contact <MailTo email="registration@gr8conf.org"/> for more information.</p>
                                <p className="small small-print"><strong>Cancellation policy</strong>:</p>
                                <p className="small small-print">
                                    In case an attendee has to cancel her/his ticket, the following rules apply:
                                </p>
                                <Grid>
                                    <Row>
                                        <Col xs={4} sm={2} className="small small-print">+4 weeks</Col>
                                        <Col xs={8} sm={10} className="small small-print">
                                            Full refund, because we understand that life works in mysterious ways. We do charge a €25 refund fee.
                                        </Col>
                                        <Col xs={4} sm={2} className="small small-print">+2 weeks</Col>
                                        <Col xs={8} sm={10} className="small small-print">
                                            50% refund, because we ordered some swag for you
                                        </Col>
                                        <Col xs={4} sm={2} className="small small-print">+1 week</Col>
                                        <Col xs={8} sm={10} className="small small-print">
                                            25% refund, because it's getting really close to conference start by now
                                        </Col>
                                        <Col xs={4} sm={2} className="small small-print">less than a week</Col>
                                        <Col xs={8} sm={10} className="small small-print">
                                            No refund, sorry. We got everything ready for you. Can someone come instead of you?
                                        </Col>
                                    </Row>
                                </Grid>
                                <p className="small small-print">In case you need assistance, please contact <MailTo
                                    email="info@gr8conf.org"/> or click the chat
                                    window below.</p>

                            </Col>
                        </Row>
                    </Grid>
                </PagePanel>
            </Page>
        );
    }
}

export default RegistrationPage


// WEBPACK FOOTER //
// ./src/pages/registration/RegistrationPage.js